// extracted by mini-css-extract-plugin
module.exports = {"navIcon":"N5BIg","rc-tabs-bar":"AltZr","rc-tabs-tab":"PG0xO","rc-tabs-tab-active":"_0XET6","terms":"_5oi4I","orderHistory-navigation":"t+ruY","empty":"jOQKF","message":"_5MRoq"};